<div class="btn-toolbar" role="toolbar">
  <div class="btn-group" role="group">
    @if(contextStatus) {
    <button type="button" class="btn btn-secondary btn-sm" (click)="onButtonClick()">{{contextStatus!.userStoryAction}}
    </button>
    <!-- <button type="button" class="btn btn-secondary btn-sm"
      (click)="onButtonClick()">{{contextStatus.display?.user_story_status_description}}
    </button> -->

    }
  </div>
  @if(showReject){
  <div class="btn-group me-1" role="group">
    <button type="button" class="btn btn-secondary btn-sm"
      (click)="onRejectButtonClick()">{{rejectContextStatus?.userStoryAction}}
    </button>
    <!-- <button type="button" class="btn btn-secondary btn-sm"
      (click)="onRejectButtonClick()">{{rejectContextStatus.status.user_story_status_description}}
    </button> -->
  </div>
  }
</div>
